/*!
  Pioneer WFRIA HelpButton v4.0.0-beta.53
  © 2023 Wells Fargo. All rights reserved.
*/
try {
  if (!window.__PIONEER_GLOBAL__) {
    window.__PIONEER_GLOBAL__ = {
      version: "4.0.0-beta.53",
      components: ["HelpButton"]
    };
  } else if (window.__PIONEER_GLOBAL__.components && window.__PIONEER_GLOBAL__.components.indexOf("HelpButton") < 0) {
    window.__PIONEER_GLOBAL__.components.push("HelpButton");
  }
} catch (error) {
  // catching server side rendering issues - windows is not defined there!
}

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["helpAriaLabel", "helpBody", "helpFooter", "helpHeader", "helpzIndex"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from "prop-types";
import React from "react";
import BalloonButton from "../BalloonButton/BalloonButton";
import { ZINDEX } from "../common/constants";
/**
 * HelpButton is a React component used to display contextual help to the user.
 *
 * HelpButton has access to all of Button's props, such as label, kind, slim, icon, etc.
 */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const HelpButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    helpAriaLabel,
    helpBody,
    helpFooter,
    helpHeader,
    helpzIndex
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return _jsx(BalloonButton, _objectSpread({
    balloonAriaLabel: helpAriaLabel,
    balloonHeader: helpHeader,
    balloonBody: helpBody,
    balloonFooter: helpFooter,
    balloonzIndex: helpzIndex,
    ref: ref
  }, otherProps));
});
HelpButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The content to be displayed in the body of the balloon. */
  helpBody: PropTypes.node.isRequired,

  /**
   * This prop should be set if the Button is not an icon only button
   * and helpHeader prop is not provided.
   */
  helpAriaLabel: PropTypes.string,

  /** The content to be displayed in the footer of the balloon. */
  helpFooter: PropTypes.node,

  /** The content to be displayed in the header of the balloon. */
  helpHeader: PropTypes.node,

  /** The zIndex of the balloon in relation to other elements on the page. */
  helpzIndex: PropTypes.number
} : {};
HelpButton.defaultProps = {
  helpAriaLabel: null,
  helpFooter: null,
  helpHeader: null,
  helpzIndex: ZINDEX.BALLOON_BUTTON
};
HelpButton.displayName = "HelpButton";
export default HelpButton;